export default __webpack_public_path__ + "static/media/bg-blue-abs6.ef30b46d.jpg";